<template>
	<vxe-modal v-model="modal" width="1000" height="1000" @show="show" @hdie="hide" :title="title + ' | 群名： '+  roomname"
		destroy-on-close :showFooter="false">
		<template #default>
			<el-container class="full" style="box-sizing: border-box;overflow: hidden;">
				<!-- <el-header>Header</el-header> -->
				<el-main style="position: relative;padding: 0;height: 750px;">
					<el-container class="full" style="box-sizing: border-box;">
						<el-aside width="250px" style="background-color: #2e3238;position: relative;">
							<purchaseorderList ref="purchaseorderList" :row="row" @orderchange="orderchange" />
						</el-aside>
						<el-container style="background-color: #eee;">
							<el-main style="position: relative;">
								<div class="full" style="box-sizing: border-box;position: relative;width: 650px;">
									<div v-for="(item,index) in message" :key="index" style="margin-bottom: 20px;">
										<div class="contentList other flex"
											v-if="item.contactid!='wxid_b8j9l2cdukpt22'">
											<div class="contentAvatar">
												<img class="avatar full" :src="item.contactavatar">
											</div>
											<div class="contentBox flex">
												<div class="name">{{item.contactname}} {{item.createdAt}}</div>
												<div class="text" v-if="item.text">{{item.text}}</div>
												<div class="img" v-if="item.img">
													<el-image style="width: 100%" :src="item.img"
														:preview-src-list="srcList">
													</el-image>
												</div>
											</div>

										</div>
										<div class="contentList self flex" v-else>
											<div class="contentBox flex">
												<div class="name">{{item.contactname}} {{item.createdAt}}</div>
												<div class="text">{{item.text}}</div>
											</div>
											<div class="contentAvatar">
												<img class="avatar full" :src="item.contactavatar">
											</div>
										</div>
									</div>
									<div style="height: 100px;position: relative;"></div>
								</div>
							</el-main>
							<el-footer class="footer" style="height: 200px;padding: 0;">
								<div class="toolbar flex">
									<el-button size="mini" type="primary">图片</el-button>
									<el-button size="mini" type="primary" @click="reportingGoods">报货</el-button>
									<el-button size="mini" type="primary" @click="reminder">催单</el-button>
								</div>
								<textarea resize="none" class="textarea" placeholder="Textarea"></textarea>
							</el-footer>
						</el-container>
					</el-container>
				</el-main>
				<el-footer class="footer" style="height: 250px;padding: 0;">
					<purchaseorderDetail ref="purchaseorderDetail" :row="row" />
				</el-footer>

			</el-container>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
		</template>

	</vxe-modal>
</template>
<style scoped>
	.footer {
		position: relative;
		background-color: white;
		box-sizing: border-box;
	}

	.toolbar {
		position: relative;
		width: 100%;
		height: 40px;
		background-color: rgb(233, 233, 235);
		flex-direction: row;
		align-items: center;
		box-sizing: border-box;
		padding: 0 10px;
		box-shadow: 0 0 4px gray;

	}

	.textarea {
		position: relative;
		padding: 0;
		margin: 0;
		border: 0;
		width: 100%;
		height: 150px;
		resize: none;
		box-sizing: border-box;
		padding: 10px;
		font-size: 16px;
	}

	.contentList {
		flex-direction: row;
	}

	.contentAvatar {
		position: relative;
		width: 50px;
		height: 50px;
		margin-right: 10px;
	}

	.avatar {
		width: 50px;
		height: 50px;
		margin-top: 6px;
	}

	.contentBox {
		flex-direction: column;

	}

	.name {
		margin-bottom: 6px;
		color: darkgray;
	}

	.text {
		display: inline-block;
		position: relative;
		padding: 10px;
		font-size: 16px;
		max-width: 400px;
		background-color: white;
		word-break: break-all;
		border-radius: 6px;
		align-self: flex-start;
	}

	.img {
		display: inline-block;
		position: relative;
		width: 100px;
	}

	.text:before {
		content: '';
		position: absolute;
		top: 9px;
		right: 100%;
		border: 6px solid transparent;
		border-right-color: white;
	}

	.self.contentList {
		justify-content: flex-end;
	}

	.self>.contentAvatar {
		margin-right: 0px;
		margin-left: 10px;
	}

	.self>.contentBox {
		align-items: flex-end;
	}

	.self>.contentBox>.name {
		position: relative;
		right: 0;
	}

	.self>.contentBox>.text {
		background-color: #b2e281;
	}

	.self>.contentBox>.text:before {
		content: '';
		position: absolute;
		top: 9px;
		left: 100%;
		border: 6px solid transparent;
		border-left-color: #b2e281;
	}
</style>
<style>
	.viewer-download {
		position: relative !important;
		width: 50px !important;
		height: 50px !important;
	}

	.viewer-download::before {
		content: "关联";
		color: white;
		display: block;
		font-size: 12px;
		position: absolute;
		width: 100%;
		height: 100%;
		line-height: 48px;
	}
</style>
<script>
	import purchaseorderList from './components/purchaseorderList/index.vue'
	import purchaseorderDetail from './components/purchaseorderDetail/index.vue'
	export default {
		props: {
			title: {
				type: String,
				default: () => {
					return '供应商'
				}
			},
			row: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				tableData: [{
						id: 10001,
						name: 'Test1',
						role: 'Develop',
						sex: 'Man',
						age: 28,
						address: 'test abc'
					},
					{
						id: 10002,
						name: 'Test2',
						role: 'Test',
						sex: 'Women',
						age: 22,
						address: 'Guangzhou'
					},
					{
						id: 10003,
						name: 'Test3',
						role: 'PM',
						sex: 'Man',
						age: 32,
						address: 'Shanghai'
					},
					{
						id: 10004,
						name: 'Test4',
						role: 'Designer',
						sex: 'Women',
						age: 24,
						address: 'Shanghai'
					}
				],
				id: 0,
				modal: false,
				loading: false,
				purchase: [],
				message: [],
				srcList: [],
				roomname: '',
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				this.getMessage()

			},
			getMessage() {
				let roomid = this.row.wxroom
				this.srcList = []
				this.$api.wechaty.getMessage(roomid.split('@')[0]).then((res) => {
					res.forEach((item) => {
						this.roomname = item.roomname
						if (item.img) {
							item.img = 'http://47.98.231.105/api/public/download/wechaty/img/' + item.img
							this.srcList.push(item.img)
						}
					})
					this.message = res
					console.log(res)
				})
			},
			reportingGoods() {
				let order = this.$refs.purchaseorderList.getActiveOrder()
				if (order) {
					if(order.status==3){
						this.$message.error(order.billCode + '单据已完成')
					}else{
						this.$message.success(order.billCode + ' 发送报货信息')
					}
				} else {
					this.$message.error('请选择采购订单')
				}
			},
			reminder() {
				let order = this.$refs.purchaseorderList.getActiveOrder()
				if (order) {
					if(order.status==3){
						this.$message.error(order.billCode + '单据已完成')
					}else{
						this.$message.success(order.billCode + ' 发送催单信息')
					}
					
				} else {
					this.$message.error('请选择采购订单')
				}
			},
			orderchange(e) {
				if (e.order) {
					this.$refs.purchaseorderDetail.getPurchaseDetail(e.order.billID)
				}
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.message = []
				this.srcList = []
				this.roomname = ''
				this.$emit('hide')
			},
			show() {
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			timestampToDate(timestamp) {
				return window.systemMethods.timestampToDate(timestamp, true)
			}
		},
		components: {
			purchaseorderList,
			purchaseorderDetail
		}
	}
</script>
